import React, { useState, useEffect } from 'react';
import '../styles/aichatmockup.css';

const AIChatMockup = () => {
  const [stage, setStage] = useState(0);

  useEffect(() => {
    // Animation loop sequence
    const runSequence = async () => {
      while (true) {
        setStage(0); // Reset
        await new Promise(r => setTimeout(r, 1000));
        
        setStage(1); // User types question
        await new Promise(r => setTimeout(r, 1500));
        
        setStage(2); // AI is typing
        await new Promise(r => setTimeout(r, 2000));
        
        setStage(3); // AI answers with chart
        await new Promise(r => setTimeout(r, 6000));
      }
    };

    runSequence();
  }, []);

  return (
    <div className="ai-mockup-wrapper">
      <div className="ai-mockup-window">
        {/* Header (optional, usually clean) */}
        
        {/* Chat Area */}
        <div className="ai-mockup-chat">
          
          {/* User Message */}
          <div className={`mockup-msg user-msg ${stage >= 1 ? 'visible' : ''}`}>
            <p>¿Me puedes hacer una predicción de ventas para la próxima semana?</p>
          </div>

          {/* AI Typing Indicator */}
          <div className={`mockup-msg ai-msg ${stage === 2 ? 'visible' : 'hidden'}`}>
            <div className="ai-header">
              <svg className="ai-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83" />
              </svg>
              <span>ClubsAgent AI está pensando...</span>
            </div>
          </div>

          {/* AI Answer with Chart */}
          <div className={`mockup-msg ai-msg ${stage >= 3 ? 'visible' : ''} ${stage === 2 ? 'hidden' : ''}`}>
            <div className="ai-header">
              <svg className="ai-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83" />
              </svg>
              <span>ClubsAgent AI</span>
            </div>
            <div className="ai-content">
              <p>Basado en tu histórico reciente y la tendencia de dispensación de Flores de CBD, se espera un <strong>aumento del 18%</strong> en volumen total.</p>
              
              {/* Fake CSS Chart */}
              <div className="mockup-chart">
                <div className="chart-col"><div className="bar" style={{height: "40%"}}></div><span>Lun</span></div>
                <div className="chart-col"><div className="bar" style={{height: "60%"}}></div><span>Mar</span></div>
                <div className="chart-col"><div className="bar" style={{height: "55%"}}></div><span>Mié</span></div>
                <div className="chart-col"><div className="bar" style={{height: "80%"}}></div><span>Jue</span></div>
                <div className="chart-col"><div className="bar highlight" style={{height: "100%"}}></div><span>Vie</span></div>
              </div>
              <p className="chart-note">El viernes será el día de mayor rotación.</p>
            </div>
          </div>

        </div>

        {/* Input Area */}
        <div className="ai-mockup-input-area">
          <div className="mockup-input-box">
            <span className="placeholder">Escribe tu pregunta...</span>
            <button className="send-btn">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="22" y1="2" x2="11" y2="13"></line>
                <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
              </svg>
            </button>
          </div>
          <div className="disclaimer">
            <span>✨ La IA puede cometer errores. Verifica lo importante.</span>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AIChatMockup;
